export const companiesCompanyIdFreeTrialDevelopersTable = "/companies/:company_id/free_trial/developers_table";
